export interface PaymentMethod {
    id?: number;
    name: string;
    is_active?: boolean;
    created_at?: string;
    updated_at?: string;
}

export interface PaymentMethodDataForm {
    id?: number;
    name: string;
    is_active?: boolean;
}

export const defaultPaymentMethodDataForm: PaymentMethodDataForm = {
    name: '',
    is_active: true
};

export interface PaymentMethodFilters {
    id?: number | null;
    name?: string | '';
    is_active?: boolean | '';
    page: number;
    per_page: number;
    sort: string;
    order: string;
}
